import React from "react";
import { useDocumentMeta } from "../components/useDocumentMeta";
import { caseStudies } from "../content/cases";
import CaseCard from "../components/CaseCard";
import CtaBand from "../components/CtaBand";

function Work() {
  useDocumentMeta(
    "Track record",
    "Volvo Group, IKEA, Volvo Cars, Länsförsäkringar and more — Internal Developer Platforms built in production, at scale.",
  );

  return (
    <>
      <section className="page-hero">
        <div className="container">
          <p className="kicker">Track record</p>
          <h1 className="page-title">Done for real, at scale</h1>
          <p className="page-lead">
            Staffing up Developer platform initiatives for some of the Nordics'
            most demanding organisations. Here's what that looks like in
            practice.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container case-list">
          {caseStudies.map((study) => (
            <CaseCard key={study.slug} study={study} />
          ))}
        </div>
      </section>

      <CtaBand
        title="Could your platform be next?"
        text="Tell us where you're stuck. We've probably seen it before."
        to="/contact"
        label="Talk to us"
      />
    </>
  );
}

export default Work;
